import { ReactNode } from 'react';
import ReactDOM from 'react-dom';

import { WeeeIcon } from '@/components/common/Icon';

import { twMerge } from 'tailwind-merge';

type toastProps = {
  text: string | ReactNode | ReactNode[];
  duration?: number;
  position?: 'bottom' | 'center';
  className?: string;
  innerClassName?: string;
  textClassName?: string;
  btnClassName?: string;
  iconType?: string;
  showIcon?: boolean;
  isTextHtml?: boolean;
  btnText?: string | ReactNode | ReactNode[];
  handleclick?: () => void;
  afterRemove?: () => void;
};

const ToastElement = (props: toastProps) => {
  const {
    text,
    position,
    className,
    showIcon,
    btnText,
    handleclick,
    iconType = 'iconicon-color-information',
    innerClassName,
    textClassName,
    btnClassName,
    isTextHtml
  } = props;

  return (
    <div
      data-testid="wid-common-toast"
      style={{ transform: 'translateZ(10px)' }}
      className={twMerge(
        'fixed z-[3000] left-0 right-0 px-5 flex max-w-[750px] mx-auto',
        position === 'center' ? 'top-1/2' : 'bottom-24',
        className
      )}>
      <div
        className={twMerge(
          'inline-flex items-center justify-between',
          'px-5 py-3 w-auto mx-auto box-border rounded-500',
          'bg-tint-black-800',
          'text-reserved-true-white enki-body-xs max-w-[750px] mx-auto',
          btnText ? 'w-80' : '',
          innerClassName
        )}>
        <div
          data-testid="wid-common-toast-content"
          className={twMerge('max-full text-left', textClassName)}
          style={{ wordBreak: 'break-word' }}>
          {showIcon && (
            <WeeeIcon data-testid="wid-common-toast-icon" type={iconType} className="mr-2" style={{ fontSize: 20 }} />
          )}
          {isTextHtml ? (
            <div
              data-testid="wid-common-toast-text"
              dangerouslySetInnerHTML={{
                __html: text as string
              }}
            />
          ) : (
            text
          )}
        </div>
        {btnText && (
          <div data-testid="btn-right" onClick={handleclick} className={btnClassName}>
            {btnText}
          </div>
        )}
      </div>
    </div>
  );
};

const Toast = ({
  text,
  duration = 3000,
  position = 'bottom',
  className,
  iconType,
  showIcon = true,
  btnText,
  afterRemove,
  handleclick,
  innerClassName,
  textClassName,
  isTextHtml = false
}: toastProps) => {
  let toastTimer = null;
  if (toastTimer) clearTimeout(toastTimer);

  removeToast();

  let div = document.createElement('div');
  div.id = 'showToast';
  document.body.appendChild(div);
  ReactDOM.render(
    <ToastElement
      text={text}
      position={position}
      showIcon={showIcon}
      className={className}
      innerClassName={innerClassName}
      textClassName={textClassName}
      iconType={iconType}
      btnText={btnText}
      isTextHtml={isTextHtml}
      handleclick={handleclick}
    />,
    div
  );

  toastTimer = setTimeout(() => {
    if (div) {
      ReactDOM.unmountComponentAtNode(div);
      div.parentNode?.removeChild(div);
      afterRemove && afterRemove();
    }
  }, duration);
};

const removeToast = () => {
  let div = document.getElementById('showToast');
  if (div) {
    ReactDOM.unmountComponentAtNode(div);
    div.parentNode?.removeChild(div);
  }
};

export { Toast, removeToast };
